module.exports = __webpack_public_path__ + "assets/img/iconfont.2d898e36.svg";